import {
  NonSyncingChildDocumentProperties,
  NonSyncingParentDocumentProperties,
} from '../nonSyncingDocumentProperties';
import { AnyDocument, Category } from '../types';

// NOTE: this function mutates the document passed as a param. The reason for
//  this is that this function can be called a looot, so performance is important.
export default (doc: AnyDocument): void => {
  // claude eslint: deleting dynamic non-syncing property keys from a generic AnyDocument union type; no narrower type supports arbitrary string key deletion
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const mutableDoc = doc as unknown as { [key: string]: unknown };
  if ([Category.Highlight, Category.Note].includes(doc.category)) {
    NonSyncingChildDocumentProperties.forEach((prop) => {
      delete mutableDoc[prop];
    });
  } else {
    NonSyncingParentDocumentProperties.forEach((prop) => {
      delete mutableDoc[prop];
    });
  }
};
